export default __webpack_public_path__ + "static/media/img-funding.d350336d.png";